import CustomModal from "../CustomModal";

function AccessToggleModal({
  isOpen,
  handleClose,
  userProfile,
  onConfirm,
  mode = "enable",
}) {
  if (!userProfile) return null;

  const isEnabling = mode === "enable";

  const headingText = isEnabling
    ? "Are you sure you want to enable user access for the selected user?"
    : "Are you sure you want to disable user access for the selected user?";

  const noteText = isEnabling
    ? "Note that enabling user access will allow the user to have access to the gym premises or any associated services."
    : "Note that disabling user access will prevent the member from entering the gym premises and using any associated services.";

  const buttonLabel = isEnabling ? "Grant access" : "Disable access";
  const buttonColor = isEnabling ? "#34B159" : "#DD9828";

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      className="delete-modal"
    >
      <div className="inner-member">
        <img
          src={`${process.env.PUBLIC_URL}/images/disable-modal-img.png`}
          alt="Access toggle icon"
        />
        <b>
          <p>{headingText}</p>
        </b>

        <div className="details-container container">
          <div className="detail">
            <p>Name</p>
            <b>
              <p className="D">
                {userProfile.l_name} {userProfile.f_name}
              </p>
            </b>
          </div>
          <div className="detail">
            <p>Gym Number</p>
            <b>
              <p className="D">#{userProfile.id}</p>
            </b>
          </div>
          <div className="detail">
            <p>Access Status</p>
            <b>
              <p className="D">
                {userProfile.access_status === 1 ? "Enabled" : "Disabled"}
              </p>
            </b>
          </div>
        </div>

        <div className="warning">
          <img
            src={`${process.env.PUBLIC_URL}/images/info-circle.png`}
            alt="Information icon"
          />
          <p>{noteText}</p>
        </div>

        <div className="inner-member-btn">
          <button onClick={handleClose}>Cancel</button>
          <button
            style={{ backgroundColor: buttonColor, color: "#FAFAFA" }}
            onClick={onConfirm}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </CustomModal>
  );
}

export default AccessToggleModal;
